import { render, staticRenderFns } from "./ImportFromFile.vue?vue&type=template&id=234f45e2&scoped=true&"
import script from "./ImportFromFile.vue?vue&type=script&lang=js&"
export * from "./ImportFromFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234f45e2",
  null
  
)

export default component.exports